import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  AUTH_REQUEST,
  AUTH_SUCCESS,
  AUTH_FAILURE,
  AUTH_RESET,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_RESET,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  CHANGE_PASSWORD_RESET,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILURE,
  // RESET_PASSWORD_RESET,
  USER_EDIT_PROFILE_REQUEST,
  USER_EDIT_PROFILE_SUCCESS,
  USER_EDIT_PROFILE_FAILURE,
  LOGOUT_REQUEST,
  AUTH_OPEN_RESPONSE_MODAL,
} from './../../constants'

export function authenticate(payload) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/login`,
      method: 'POST',
      types: [
        LOGIN_REQUEST,
        LOGIN_SUCCESS,
        LOGIN_FAILURE,
      ],
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
  }
}

export function auth(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/auth`,
      method: 'POST',
      types: [
        AUTH_REQUEST,
        AUTH_SUCCESS,
        AUTH_FAILURE,
      ],
      headers: {
        'Content-Type': 'application/json',
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editProfile(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/users/profile`,
      method: 'PUT',
      types: [
        USER_EDIT_PROFILE_REQUEST,
        USER_EDIT_PROFILE_SUCCESS,
        USER_EDIT_PROFILE_FAILURE,
      ],
      headers: {
        'Content-Type': 'application/json',
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function resetPassword(payload) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/auth/reset-password`,
      method: 'POST',
      types: [
        RESET_PASSWORD_REQUEST,
        RESET_PASSWORD_SUCCESS,
        RESET_PASSWORD_FAILURE,
      ],
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    },
  }
}

export function changePassword(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/auth/change-password`,
      method: 'POST',
      types: [
        CHANGE_PASSWORD_REQUEST,
        CHANGE_PASSWORD_SUCCESS,
        CHANGE_PASSWORD_FAILURE,
      ],
      headers: {
        'Content-Type': 'application/json',
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function openResponseModal(payload) {
  return {
    type: AUTH_OPEN_RESPONSE_MODAL,
    payload,
  }
}

export function logout() {
  return {
    type: LOGOUT_REQUEST,
  }
}
export function resetAuthUser() {
  return {
    type: AUTH_RESET,
  }
}
export function resetAuth() {
  return {
    type: LOGIN_RESET,
  }
}
export function resetChangePassword() {
  return {
    type: CHANGE_PASSWORD_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/auth/auth-action.js